var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rank-component"},[_vm._l((_vm.list),function(item,index){return [_c('div',{key:index},[_c('span',[_vm._v(_vm._s(index+1))]),_c('span',[_vm._v(_vm._s(item.userName))]),_c('span',[_vm._v(_vm._s(item.proNum))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }